import { Box } from '@mui/material';
import { Route,Routes } from 'react-router-dom';
import VehicleCategoriesTable from '../component/vehicleCategories/vehicleCategoriesTable';


const VehicleCategoriesPlanning = () => {
    return (
        <Box>
            <Routes>
                <Route path="/" element={<VehicleCategoriesTable/>}/>
            </Routes> 
        </Box>
    );
}

export default VehicleCategoriesPlanning;
